import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Link } from "react-router-dom";
import { useStores } from "../../stores";
import { isMobile } from 'react-device-detect';
import { observer } from 'mobx-react-lite';

type EnabledSubMenuItemProps = {
    id: string;
    to: string;
    text: string;
    disabled?: false;
};

type DisabledSubMenuItemProps = {
    id: string;
    text: string;
    disabled: true;
};

type Props = EnabledSubMenuItemProps | DisabledSubMenuItemProps;

const SideBarSubMenuItem = observer((props: Props) => {
    const { panelStore } = useStores();

    const handleClick = () => {
        if (isMobile) {
            panelStore.setCollapsed(true);
        }
    };

    if (props.disabled) {
        return (
            <ListItemButton
                id={props.id}
                sx={{ pl: 4 }}
                disabled
            >
                <ListItemText primary={props.text} />
            </ListItemButton>
        );
    }

    return (
        <ListItemButton
            id={props.id}
            sx={{ pl: 4 }}
            component={Link}
            to={props.to}
            onClick={handleClick}
        >
            <ListItemText primary={props.text} />
        </ListItemButton>
    );
});

export default SideBarSubMenuItem;
